export enum AreaLevel {
  STATISTICAL_SECTOR = 'StatSec',
  MUNICIPALITY = 'Municipality',
  DISTRICT = 'District',
  PROVINCE = 'Province',
  REGION = 'Region',
  COUNTRY = 'Country',
}
